import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { JsonViewer } from '@dataxpdtn/mui-json-viewer';
import { useContext } from 'react';
import { AppMainViewContext } from '../../../ContextProviders/AppContextProvider';
import { Stack, Typography } from '@mui/material';
import { edgeTypeMatrix } from '@iotv/datamodel';
export const Slot5 = ({}) => {
    const [{ userSelectedGroup, roleArbitrationInstance }] = useContext(AppMainViewContext);
    const getTypeTableRow = ({ sourceObjectType, targetObjectType }) => {
        const x = roleArbitrationInstance?.getObjectControlActionsByType({ sourceObjectType, targetObjectType }) ?? { x: 'NO RAI' };
        return (_jsxs(Stack, { direction: 'row', children: [_jsx(Stack, { flex: 1, children: _jsx(Typography, { children: sourceObjectType }) }), _jsx(Stack, { flex: 1, children: _jsx(Typography, { children: targetObjectType }) }), _jsx(Stack, { flex: 10, children: _jsx(JsonViewer, { value: x,
                        objectSortKeys: true,
                        displayComma: false,
                        displaySize: false,
                        collapseStringsAfterLength: 300,
                        quotesOnKeys: false,
                        displayDataTypes: false,
                        rootName: 'Log Entry',
                        enableClipboard: true,
                        groupArraysAfterLength: undefined,
                        keyRenderer: undefined,
                        defaultInspectDepth: 3,
                        editable: false,
                        sx: { fontFamily: 'monospace', fontSize: 20, font: 'inherit' } }) })] }, `${sourceObjectType}>${targetObjectType}`));
    };
    const typeEntries = Object.entries(edgeTypeMatrix).reduce((a, [sourceObjectType, targetEdgeTypeMap]) => {
        const params = Object.keys(targetEdgeTypeMap).map((targetObjectType) => {
            return { sourceObjectType, targetObjectType };
        });
        a.push(...params);
        return a;
    }, []);
    return _jsx(Stack, { direction: 'column', width: '100%', children: typeEntries.map(getTypeTableRow) });
};
